import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'What sizes of caravans, boats and motorhomes do you accommodate?',
  answer: 'Our standard bays are 9 meters long by 3 meters wide. This covers most single and dual axle caravans, camper trailers, boats and motorhomes. If you have a larger vehicle, please contact us to discuss options.'
}, {
  question: 'What security measures are in place?',
  answer: "Security is our top priority. Our facility will feature 24/7 video security camera monitoring and secure gated access. We're currently evaluating sites and looking at options with residential caretakers living on site for added security and peace of mind."
}, {
  question: 'Can I access my caravan, boat or motorhome at any time?',
  answer: 'We plan to offer convenient access hours from 7:00 AM to 7:00 PM, seven days a week. 24/7 access may be available upon request. Final access hours will be confirmed once our site is secured.'
}, {
  question: 'Do I need to have insurance for my vehicle?',
  answer: 'Yes, we require all stored vehicles to have comprehensive insurance. While our facility is secure and monitored, we require you to maintain your own insurance coverage for complete peace of mind.'
}, {
  question: 'Are there any long-term contracts?',
  answer: 'No! We offer flexible month-by-month terms with no long-term commitments required. This gives you the freedom to store your caravan or boat for as long or as short as you need.'
}, {
  question: 'Why should I join the priority list now?',
  answer: 'Storage capacity will be limited at launch. Priority list members receive first access to available bays and early bird pricing before we open to the wider public.'
}, {
  question: 'Am I committed if I join the priority list?',
  answer: "Not at all! Registering is completely free and carries no obligation. It simply adds you to our priority waitlist so you'll be among the first to hear about our opening and secure early bird pricing. You can decide whether to proceed when we contact you with final details."
}, {
  question: 'When will the facility open?',
  answer: "We're currently evaluating several sites within 35kms of Perth CBD. Once we secure the perfect location, we'll notify all registered customers with an opening timeline. Early bird registrations will receive priority access."
}, {
  question: 'Where will the site be located?',
  answer: "Our first site will be located within Perth's northern corridor. We've already assessed several suitable properties and are currently focusing on options in Neerabup and Bullsbrook."
}, {
  question: 'What happens after I register my interest?',
  answer: "We'll be in touch as we get closer to our opening date with site location and details."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-white" data-id="element-149">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900 mb-4" data-id="element-152">
            Frequently Asked <span className="text-[#1A7B7E]" data-id="element-153">Questions</span>
          </h2>
          <div className="h-1 w-24 bg-[#FFC107] mx-auto rounded-full" data-id="element-154"></div>
          <p className="mt-4 text-xl text-gray-600" data-id="element-155">
            Got questions? We've got answers.
          </p>
        </div>

        <div className="space-y-4" data-id="element-156">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#1A7B7E]/30 transition-colors" data-id="element-157">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-158">
                <span className="text-lg font-bold text-gray-900 pr-8" data-id="element-159">
                  {faq.question}
                </span>
                <ChevronDown className={`h-5 w-5 text-[#1A7B7E] flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-160" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-161">
                <div className="p-6 pt-0 text-gray-600 leading-relaxed" data-id="element-162">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center p-8 bg-gray-50 rounded-lg border border-gray-100" data-id="element-163">
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-164">
            Still have questions?
          </h3>
          <p className="text-gray-600 mb-4" data-id="element-165">
            We're here to help! Get in touch and we'll answer any questions you
            have.
          </p>
          <a href="#contact" className="inline-flex items-center text-[#1A7B7E] font-bold hover:text-[#156066] transition-colors" data-id="element-166">
            Contact Us →
          </a>
        </div>
      </div>
    </section>;
}